import React from 'react';
import classnames from 'classnames';

import { usePlaygroundDispatch, usePlaygroundState } from './context';

const PlaygroundNav = ({ label, items = [] }) => {
  const dispatch = usePlaygroundDispatch();
  const { activeSection } = usePlaygroundState();

  if (!items || items.length === 0) return null;

  return (
    <div className="w-full">
      {
        <p className="text-light-haiti uppercase tracking-wider text-xs mb-6">
          {label}
        </p>
      }

      <div className="border-l border-light-haiti space-y-2">
        {items.map((item, index) => {
          const isActive = item === activeSection;

          return (
            <button
              key={index}
              className={classnames(
                'text-sm py-1 px-3 w-full block focus:outline-none -ml-px text-left border-l',
                {
                  'border-transparent text-light-haiti': !isActive,
                  'text-white border-white': isActive,
                }
              )}
              onClick={() => dispatch({ type: 'SET_ACTIVE', section: item })}
            >
              {item.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default PlaygroundNav;
